<template>
    <section id="hero" class="sp-hero">
        <!-- Fondo de carretera y orbes de luz ambiental -->
        <picture class="sp-hero__bg">
            <source srcset="layout/images/hero-truck-bg.webp" type="image/webp" />
            <img src="layout/images/hero-truck-bg.png" alt="" fetchpriority="high" decoding="async" />
        </picture>
        <span class="sp-hero__veil" aria-hidden="true"></span>
        
        <!-- Orbes de luz decorativos -->
        <div class="sp-glow-orb sp-glow-orb--orange" style="top: 15%; right: 10%; width: 450px; height: 450px;"></div>
        <div class="sp-glow-orb sp-glow-orb--cyan" style="bottom: 10%; left: 5%; width: 350px; height: 350px;"></div>

        <div class="sp-container sp-hero__inner">
            <div class="sp-hero__copy sp-reveal">
                <!-- Eyebrow con estado en vivo -->
                <div class="sp-eyebrow">
                    <span class="sp-live-dot"></span>
                    <span>Publicidad geolocalizada en ruta</span>
                </div>

                <!-- Único H1 de la página -->
                <h1 class="sp-h1 sp-hero__titulo">
                    Haz que tu negocio <span class="sp-accent">aparezca en la ruta</span> justo
                    cuando el conductor te necesita
                </h1>

                <p class="sp-lead sp-hero__sub">
                    Conecta tu restaurante, hotel, montallantas, estación de servicio o taller con
                    miles de conductores de carga pesada que circulan en tiempo real cerca de tu sede.
                </p>

                <div class="sp-hero__ctas">
                    <button type="button" class="sp-btn sp-btn--primary" @click="$emit('anunciarme')">
                        <span>Quiero anunciar mi negocio</span>
                        <i class="pi pi-arrow-right" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="sp-btn sp-btn--outline" @click="$emit('ir-a', 'como-funciona')">
                        <i class="pi pi-play-circle" aria-hidden="true"></i>
                        <span>Ver cómo funciona</span>
                    </button>
                </div>

                <ul class="sp-hero__pills">
                    <li v-for="(pill, idx) in pills" :key="pill.texto" :class="'sp-delay-' + (idx + 1)">
                        <div class="sp-hero__pill-icon">
                            <i :class="'pi ' + pill.icon" aria-hidden="true"></i>
                        </div>
                        <span v-html="pill.texto"></span>
                    </li>
                </ul>
            </div>

            <div class="sp-hero__mockup">
                <PhoneMockup />
            </div>
        </div>

        <!-- Barra de Social Proof / Métricas clave en vivo -->
        <div class="sp-container sp-hero__stats-container sp-reveal sp-delay-2">
            <div class="sp-hero__stats">
                <div class="sp-hero__stat-item">
                    <div class="sp-hero__stat-icon">
                        <i class="pi pi-users"></i>
                    </div>
                    <div>
                        <strong>+50,000</strong>
                        <span>Conductores activos en la red</span>
                    </div>
                </div>

                <div class="sp-hero__stat-item">
                    <div class="sp-hero__stat-icon">
                        <i class="pi pi-map"></i>
                    </div>
                    <div>
                        <strong>100+</strong>
                        <span>Rutas nacionales conectadas</span>
                    </div>
                </div>

                <div class="sp-hero__stat-item">
                    <div class="sp-hero__stat-icon">
                        <i class="pi pi-building"></i>
                    </div>
                    <div>
                        <strong>+350</strong>
                        <span>Comercios y sedes aliadas</span>
                    </div>
                </div>

                <div class="sp-hero__stat-item">
                    <div class="sp-hero__stat-icon">
                        <i class="pi pi-chart-line"></i>
                    </div>
                    <div>
                        <strong>100%</strong>
                        <span>Medición y resultados en vivo</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import PhoneMockup from './PhoneMockup';

export default {
    name: 'NegociosHero',
    emits: ['anunciarme', 'ir-a'],
    components: { PhoneMockup },
    data() {
        return {
            pills: [
                { icon: 'pi-map-marker', texto: 'Publicidad<br>geolocalizada' },
                { icon: 'pi-users', texto: 'Público<br>especializado' },
                { icon: 'pi-calendar', texto: 'Campañas<br>flexibles por días' },
                { icon: 'pi-chart-bar', texto: 'Mide tus<br>resultados' }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.sp-hero {
    position: relative;
    isolation: isolate;
    overflow: hidden;
    padding-top: clamp(2.5rem, 6vw, 4.5rem);
    padding-bottom: clamp(3rem, 6vw, 4.5rem);
    background: var(--sp-surface-alt);
    scroll-margin-top: var(--sp-header-h);
}

.sp-hero__bg {
    position: absolute;
    inset: 0;
    z-index: -2;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 65% 50%;
    }
}

.sp-hero__veil {
    position: absolute;
    inset: 0;
    z-index: -1;
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.97) 0%,
        rgba(244, 247, 249, 0.92) 55%,
        rgba(244, 247, 249, 0.86) 100%
    );
}

.sp-hero__inner {
    display: grid;
    grid-template-columns: 1fr;
    gap: clamp(2.5rem, 5vw, 4rem);
    align-items: center;
}

.sp-hero__titulo {
    margin-top: 0.35rem;
    line-height: 1.15;
}

.sp-hero__sub {
    margin-top: 1.25rem;
}

.sp-hero__ctas {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    margin-top: 2rem;
}

.sp-hero__pills {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.2rem 1.1rem;
    margin-top: clamp(2rem, 4vw, 2.75rem);

    li {
        display: flex;
        align-items: center;
        gap: 0.8rem;
        color: var(--sp-navy);
        font-size: clamp(0.85rem, 1.1vw, 0.95rem);
        font-weight: 700;
        line-height: 1.3;
        transition: transform 0.2s ease;

        &:hover {
            transform: translateY(-2px);
            
            .sp-hero__pill-icon {
                background: var(--sp-orange);
                color: #fff;
                box-shadow: 0 4px 14px rgba(235, 93, 27, 0.4);
            }
        }
    }
}

.sp-hero__pill-icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.6rem;
    height: 2.6rem;
    background: rgba(255, 255, 255, 0.9);
    border: 2px solid var(--sp-orange);
    border-radius: 12px;
    color: var(--sp-orange);
    font-size: 1.1rem;
    box-shadow: 0 4px 12px rgba(235, 93, 27, 0.15);
    transition: all 0.2s ease;
}

.sp-hero__mockup {
    display: flex;
    justify-content: center;
}

/* Barra de Social Proof */
.sp-hero__stats-container {
    margin-top: clamp(2.5rem, 5vw, 4rem);
}

.sp-hero__stats {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
    padding: clamp(1.25rem, 2.5vw, 1.75rem) clamp(1.5rem, 3vw, 2.5rem);
    background: rgba(255, 255, 255, 0.88);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid var(--sp-border);
    border-radius: var(--sp-radius-lg);
    box-shadow: 0 10px 35px rgba(13, 48, 68, 0.07);
}

.sp-hero__stat-item {
    display: flex;
    align-items: center;
    gap: 0.9rem;

    strong {
        display: block;
        font-size: clamp(1.2rem, 2vw, 1.6rem);
        font-weight: 800;
        color: var(--sp-navy);
        line-height: 1.1;
    }

    span {
        font-size: clamp(0.78rem, 1vw, 0.86rem);
        color: var(--sp-text-soft);
        font-weight: 500;
    }
}

.sp-hero__stat-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 3rem;
    height: 3rem;
    border-radius: 14px;
    background: var(--sp-orange-50);
    border: 1px solid var(--sp-orange-100);
    color: var(--sp-orange);
    font-size: 1.3rem;
}

@media (min-width: 768px) {
    .sp-hero__pills {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .sp-hero__stats {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (min-width: 992px) {
    .sp-hero__inner {
        grid-template-columns: minmax(0, 1.08fr) minmax(0, 0.92fr);
    }

    .sp-hero__bg {
        left: 40%;
    }

    .sp-hero__veil {
        background: linear-gradient(
            95deg,
            rgba(244, 247, 249, 1) 0%,
            rgba(244, 247, 249, 0.98) 42%,
            rgba(244, 247, 249, 0.76) 54%,
            rgba(244, 247, 249, 0.28) 72%,
            rgba(244, 247, 249, 0.12) 100%
        );
    }

    .sp-hero__pills {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (min-width: 1200px) {
    .sp-hero__pills {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
}

/* Pantallas grandes: el hero medía 971px fijos, así que en un monitor de 27"
   (1440px de alto) sobraba casi medio viewport y se colaba la sección
   siguiente, dando la sensación de recorte. Aquí ocupa el primer pliegue.
   Se exige también min-height para no aplastar el contenido en pantallas
   anchas pero bajas (portátiles panorámicos). */
@media (min-width: 1600px) and (min-height: 900px) {
    .sp-hero {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: calc(100vh - var(--sp-header-h));
    }
}

/* El fondo es un cuadrado de 1024px. Con la costura al 40% en 2560px la banda
   mide 1536px y hay que ampliar la imagen 1,5x. Moviéndola a la derecha en
   pantallas muy anchas, la banda se acerca al tamaño nativo y se ve nítida. */
@media (min-width: 2000px) {
    .sp-hero__bg {
        left: 48%;
    }
}

@media (min-width: 2400px) {
    .sp-hero__bg {
        left: 52%;
    }
}

/* La foto arranca desplazada a la derecha, y el velo del hero es un degradado
   vertical, asi que su borde izquierdo quedaba como una costura recta muy
   visible. Esta mascara la difumina hacia el fondo. Si el navegador no la
   soporta simplemente se ve el borde, sin romper nada. */
@media (min-width: 992px) {
    .sp-hero__bg {
        -webkit-mask-image: linear-gradient(to right, transparent 0%, #000 22%);
        mask-image: linear-gradient(to right, transparent 0%, #000 22%);
    }
}
</style>
